import { GetStaticPaths } from 'next';
import LatestNextPage, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default LatestNextPage;
